import { render, staticRenderFns } from "./ImageUploadField.vue?vue&type=template&id=f04b8204"
import script from "./ImageUploadField.vue?vue&type=script&lang=js"
export * from "./ImageUploadField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports